// extracted by mini-css-extract-plugin
module.exports = {"layout":"J_N","content":"J_s","title":"J_f","subtitle":"J_R","subtitleBold":"J_dd","apps":"J_df","cardChat":"J_dg","chat":"J_dh","search":"J_dj","share":"J_dk"};